import React, { useEffect, useMemo, useState } from 'react'
import { Badge, Button, Col, DropdownItem, DropdownMenu, DropdownToggle, Form, FormGroup, Modal, ModalBody, Row, UncontrolledDropdown } from 'reactstrap'
import { Block, BlockBetween, BlockDes, BlockHead, BlockHeadContent, BlockTitle, Icon, ReactDataTable, RSelect } from '../../../../components/Component'
import { WEBSITE_API_URL } from '../../../../config'
import ToastExample from '../../../../helpers/toast'
import Content from '../../../../layout/content/Content'
import Head from '../../../../layout/head/Head'
import moment from 'moment'
import { useDispatch, useSelector } from 'react-redux'
import { getAllDeliveryCollectionLogs, getSingleUserDeliveryCollectionLog, } from '../../../../redux/admin/report/action'
import { nonActiveFormSubmissionStatus } from '../../../../redux/common/actions'
import DatePicker from "react-datepicker";
import subDays from "date-fns/subDays";
import { Controller, useForm } from 'react-hook-form'
import * as yup from "yup";
import { yupResolver } from '@hookform/resolvers/yup'
import { ColorRing } from 'react-loader-spinner'

const DeliveryCollectionLogs = () => {

    const dispatch = useDispatch();

    // get data from redux state
    const getSelectors = (state) => ({
        logs: state.reports.collection_logs,
    });

    const { logs } = useSelector(getSelectors);


    const [modal, setModal] = useState(false);
    // current delivery collection
    const [currentCollection, setCurrentCollection] = useState([]);


    //save selected city id
    const [city_id, setCityId] = useState(null);
    const [loading, setLoading] = useState(true);

    //display error if city not found
    const [error, setError] = useState("");

    // save date for datepicker
    const [startDate, setStartDate] = useState(subDays(new Date(), 30));
    const [endDate, setEndDate] = useState(new Date());

    const [noDate, setNoDate] = useState(false);
    const [delivery_logs, setDeliveryLogs] = useState([])

    const formatedStart = moment(startDate).format('DD-MM-yyyy');
    const formatedEnd = moment(endDate).format('DD-MM-yyyy');

    // get all delivery collection log  onload
    useEffect(() => {
        const city = "All";
        dispatch(getAllDeliveryCollectionLogs(city, formatedStart, formatedEnd)).then((response) => {
            if (response.payload.success) {
                setLoading(false);
            }
        })
    }, [])


    // delivery collection log modal
    const openOrderModal = (delivery_guy) => {
        setCurrentCollection(delivery_guy)
        dispatch(nonActiveFormSubmissionStatus());
        const token = localStorage.getItem('accessToken');
        dispatch(getSingleUserDeliveryCollectionLog(token, delivery_guy.id)).then((response) => (
            setDeliveryLogs(response.payload)
        ))
        setTimeout(() => {
            setModal(true);
        }, 100);
    };

    // on date change
    const handleDatePicker = (dates) => {
        setNoDate(false)
        const [start, end] = dates;
        setStartDate(start);
        setEndDate(end);
    }

    // filter data according to date picker

    const filterPayout = () => {
        if (startDate && endDate) {
            const formatedStart = moment(startDate).format('DD-MM-yyyy');
            const formatedEnd = moment(endDate).format('DD-MM-yyyy');
            if (city_id) {
                setTimeout(() => {
                    dispatch(getAllDeliveryCollectionLogs(city_id, formatedStart, formatedEnd));
                }, 100);
            } else {
                setError("City is Required");
            }
        } else {
            setNoDate(true)
        }
    }

    // export delivery collection report
    const onExport = () => {
        const token = localStorage.getItem('accessToken');
        if (startDate && endDate) {
            const formatedStart = moment(startDate).format('DD-MM-yyyy');
            const formatedEnd = moment(endDate).format('DD-MM-yyyy');
            if (city_id) {
                window.location = WEBSITE_API_URL + "/delivery_collection_log/export-log?token=" + token + "&from=" + formatedStart + "&to=" + formatedEnd + "&city=" + city_id;
            } else {
                setError("City is Required");
            }
        } else {
            setNoDate(true)
        }
    }


    //headers of table
    const UserHeading = [
        {
            name: "Name",
            selector: (row) => row?.user?.name,
            sortable: true,
            hide: 370,
        },
        {
            name: "Email",
            selector: (row) => row?.user?.email,
            sortable: true,
            hide: 370,
        },
        {
            name: "Phone",
            selector: (row) => row?.user?.phone,
            sortable: true,
            hide: 370,
        },
        {
            name: "Amount",
            selector: (row) => row?.amount,
            sortable: true,
            hide: "sm",

        },
        {
            name: "Message",
            selector: (row) => row?.message,
            sortable: true,
            hide: "sm",

        },
        {
            name: "Date",
            selector: (row) => moment(row.created_at).format('DD-MM-yyyy'),
            sortable: true,
            hide: "sm",

        },
        // {
        //     name: "Actions",
        //     compact: true,
        //     grow: 1,
        //     style: { paddingRight: "20px" },
        //     cell: (row) => (
        //         <div className="user-card mt-2 mb-2">
        //             <DropdownTrans row={row} />
        //         </div>

        //     ),
        //     sortable: false,
        // },
    ];

    const DropdownTrans = ({ row }) => {
        return (
            <UncontrolledDropdown>
                <DropdownToggle tag="a" className="text-soft dropdown-toggle btn btn-icon btn-trigger">
                    <Icon name="more-h"></Icon>
                </DropdownToggle>
                <DropdownMenu right>
                    <ul className="link-list-plain">
                        <li>
                            <DropdownItem  color='info' size="sm" onClick={()=>openOrderModal(row)}>
                                <Icon name="eye-fill" className="mr-1" />
                                Delivery Collection
                            </DropdownItem>
                        </li>
                    </ul>
                </DropdownMenu>
            </UncontrolledDropdown>
        );
    };

    const allOption = { value: "All", label: "All" };
    const listCity = logs?.cities?.map((city) => (
        { value: city.id, label: city.name }
    ));
    // const listCity = collections?.cities?.map((city) => (
    //     { value: city.id, label: city.name }
    // ));
    console.log(listCity, 'listCity')
    // listCity.unshift(allOption);
    // form validation schema
    const exportSchema = yup.object({

        status: yup.string().required(),
        city_id: yup.string().required(),

    });

    // schema to edit form data
    const defaultValues = useMemo(
        () => ({
            status: "",
            city_id: "",
        }),
        []
    );

    const methods = useForm({
        resolver: yupResolver(exportSchema),
        defaultValues: defaultValues,
    });

    const {
        register,
        handleSubmit,
        watch,
        control,
        formState: { errors },
        unregister,
        reset,
    } = methods;

    return (
        <React.Fragment>
            {loading ? (
                <Content >
                    <div className='d-flex align-items-center justify-content-center' style={{ minHeight: '75vh' }}>
                        <ColorRing
                            visible={true}
                            height="80"
                            width="80"
                            ariaLabel="blocks-loading"
                            wrapperStyle={{}}
                            wrapperClass="blocks-wrapper"
                            colors={['#fcc314', '#fcc314', '#fcc314', '#fcc314', '#fcc314']}
                        />
                    </div>
                </Content>
            ) :
                <React.Fragment>
                    <Head title="Delivery Collection Logs"></Head>

                    <Content>
                        <BlockHead size="sm">
                            <BlockBetween>
                                <BlockHeadContent>
                                    <BlockTitle tag="h3" page>
                                        Delivery Collection Logs
                                    </BlockTitle>
                                    <BlockDes className="text-soft">
                                        <p>You have total {logs?.count} Delivery Collection Logs .</p>


                                    </BlockDes>
                                </BlockHeadContent>

                            </BlockBetween>
                        </BlockHead>

                        <Block>
                            <Row className='mb-3'>
                                <Col md="4">
                                    <span className="form-label">Choose Date Range</span>
                                    <DatePicker
                                        selected={startDate}
                                        onChange={handleDatePicker}
                                        startDate={startDate}
                                        endDate={endDate}
                                        selectsRange
                                        dateFormat="dd-MM-yyyy"
                                        className="form-control date-picker"
                                        required
                                    />
                                    {noDate && (
                                        <span className="invalid text-danger text-italic">Please Select Date Range </span>
                                    )}
                                </Col>
                                <Col md="4">
                                    <span className="form-label">Select a City</span>

                                    <Controller
                                        name="city_id"
                                        control={control}
                                        render={({ onChange, value, ref }) => (
                                            <RSelect
                                                options={listCity}
                                                onChange={(val) => {
                                                    setCityId(val?.value)
                                                    onChange(val?.value)
                                                }}
                                                defaultValue={listCity?.find((c) => c?.value === city_id)}
                                            />
                                        )}
                                        ref={register({ required: "This field is required" })}
                                    />
                                    {!city_id && (
                                        <span className="invalid text-danger text-italic">{error}</span>
                                    )}
                                </Col>
                                <Col md="3" className='d-flex align-items-end'>
                                    <Button outline color="success" className='mx-3' onClick={() => { filterPayout() }}>

                                        <span>Filter</span>
                                    </Button>
                                    <Button outline color="primary" className='mx-3' onClick={() => { onExport() }}>
                                        <Icon name="download-cloud"></Icon>
                                        <span>Export</span>
                                    </Button>
                                </Col>
                            </Row>
                        </Block>
                        {/* datatable */}

                        <ReactDataTable
                            data={logs?.logs}
                            columns={UserHeading}
                            pagination
                        />

                    </Content>
                    {/* view collection release modal */}
                    <Modal
                        isOpen={modal}
                        toggle={() => setModal(false)}
                        className="modal-dialog-centered"
                        size="lg"
                    >
                        <ModalBody className="pt-3 pb-2">
                            <a
                                href="#cancel"
                                onClick={(ev) => {
                                    ev.preventDefault();
                                    setModal(false)
                                }}
                                className="close"
                            >
                                <Icon name="cross-sm"></Icon>
                            </a>
                            <div className='p-2'>
                            {delivery_logs.length}
                                asd


                            </div>

                        </ModalBody>
                    </Modal>
                </React.Fragment>
            }
        </React.Fragment>
    )
}

export default DeliveryCollectionLogs
